import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

/** What the snackbar shows; every `AbookSnackbarService` method fills some of it. */
export interface AbookSnackbarData {
  title: string;
  message: string;
  actionDismissText?: string;
  actionOneText?: string;
  actionOne?: () => void;
}

@Component({
    selector: 'app-abook-snackbar',
    imports: [MatButtonModule],
    templateUrl: './abook-snackbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './abook-snackbar.component.scss'
})
export class AbookSnackbarComponent {
  snackBarRef = inject<MatSnackBarRef<AbookSnackbarComponent>>(MatSnackBarRef);
  data = inject<AbookSnackbarData>(MAT_SNACK_BAR_DATA);

  actionOne(): void {
    this.snackBarRef.dismissWithAction();
    this.data.actionOne?.();
  }

  onClose(): void {
    this.snackBarRef.dismiss();
  }
}
